import {Injectable} from '@angular/core';
import {HttpClient, HttpErrorResponse, HttpHeaders} from '@angular/common/http';
import {Observable} from 'rxjs/Observable';
import {catchError} from 'rxjs/operators';
import {TokenRequest} from '../dto/token-request.dto';
import {TokenResponse} from '../dto/token-response.dto';
import {DebranchementDto} from "../dto/debranchement.dto";
import {CriteresRechercheLogsDto} from "../dto/criteres.recherche.logs.dto";
import {ResultatRechercheLogsDto} from "../dto/resultat.recherche.logs.dto";
import {ErrorObservable} from "rxjs/observable/ErrorObservable";
import {QueueDto} from "../dto/queue.dto";
import {QueueMessageDto} from "../dto/queue.message.dto";

@Injectable()
export class TowerService {

  private accessToken;

  constructor(private http: HttpClient) {
  }

  obtainToken(idToken: string): Observable<TokenResponse> {
    const request: TokenRequest = {
      idToken: idToken
    }
    return this.http.post<TokenResponse>('/api/token', request).pipe(catchError(this.handleError));
  }

  setAccessToken(token: string){
    this.accessToken = token;
  }

  getDebranchementUrl(id: number): Observable<any> {
    let url = '/api/debranchement/' + id;

    return this.http.get<any>(url, this.getRequestOptions()).pipe(catchError(this.handleError));
  }

  rechercherLogs(criteres: CriteresRechercheLogsDto): Observable<ResultatRechercheLogsDto> {
    return this.http.post<ResultatRechercheLogsDto>('/api/logs', criteres, this.getRequestOptions()).pipe(catchError(this.handleError));
  }

  recupererLogitem(id: string): Observable<any> {
    return this.http.get<any>('/api/logs/' + id, this.getRequestOptions()).pipe(catchError(this.handleError));
  }

  listerQueues(): Observable<Array<QueueDto>>  {
    return this.http.get<Array<QueueDto>>('/api/queues', this.getRequestOptions()).pipe(catchError(this.handleError));
  }

  lireQueue(queue: string): Observable<Array<QueueMessageDto>>  {
    return this.http.get<Array<QueueMessageDto>>('/api/queues/' + queue, this.getRequestOptions()).pipe(catchError(this.handleError));
  }

  injecterMessage(queue: string,message: QueueMessageDto): Observable<any>  {
    return this.http.post<any>('/api/queues/' + queue + '/move', message, this.getRequestOptions()).pipe(catchError(this.handleError));
  }

  supprimerMessage(queue: string,message: QueueMessageDto): Observable<any>  {
    return this.http.post<any>('/api/queues/' + queue + "/delete", message, this.getRequestOptions()).pipe(catchError(this.handleError));
  }

  private handleError(error: HttpErrorResponse) {
    if (error.error instanceof ErrorEvent) {
      // A client-side or network error occurred. Handle it accordingly.
      console.error('An error occurred:', error.error.message);
    } else {
      // The backend returned an unsuccessful response code.
      // The response body may contain clues as to what went wrong,
      console.error(
        `Backend returned code ${error.status}, body was: ${error.error}`);

      if (error.status === 412 && error.error.message != null && error.error.message != undefined) {
        return new ErrorObservable(error.error.message);
      }
    }
    // return an ErrorObservable with a user-facing error message
    return new ErrorObservable(
      'Une erreur s\'est produite, veuillez ré-essayer ultérieurement.');
  }

  private getRequestOptions() {
    const headers = new HttpHeaders({'Access-Token': this.accessToken});
    return { headers: headers };
  }

}



// WEBPACK FOOTER //
// ./src/app/api/service/tower.service.ts